import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { StringParam, useQueryParam, withDefault } from "use-query-params";
import {
  AppSubdomains,
  getPathForCrossAppRedirect,
} from "@akj-dev/affinity-platform";
import { SearchField } from "../SearchField";

export default function GlobalSearchToolbar() {
  const [query, setQuery] = useQueryParam(
    "search",
    withDefault(StringParam, "")
  );
  const [searchQuery, setSearchQuery] = useState(query);

  useEffect(() => {
    setSearchQuery(query);
  }, [query, setSearchQuery]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    if (!e.target.value.length) setQuery("");
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    window.location.href = getPathForCrossAppRedirect(
      AppSubdomains.HOME,
      `/search?search=${searchQuery}`
    );
  };

  return (
    <Box pl={19}>
      <SearchField
        value={searchQuery}
        onChange={handleChange}
        onSubmit={handleSubmit}
        margin="dense"
      />
    </Box>
  );
}
